import type {StepperItem} from "@/domain/type/config.type.ts";
import type {Source} from "@/domain/type/source.type.ts";

export default abstract class AbstractType {
  public abstract getStepperItems(): StepperItem[];

  public abstract sourceLeftList(): Source[];

  public abstract sourceRightList(): Source[];

  public abstract cleanFieldValue(value: string, label: string): string;

  public printField(value: string, label: string): string {

    value = this.cleanFieldValue(value, label)

    return value.replace(/&nbsp;/gi, ' ')
  }
}
